import Typography, {TypographyProps} from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

const Header = styled(Typography)<TypographyProps>(({ theme }) => ({
    fontFamily:'oswald',
    letterSpacing: '.1rem'
}))

export default Header;